
import { Component, Prop, Vue } from 'vue-property-decorator';
import InternalTicketsRepositoryInterface, { SettingType, TicketType } from '@/services/Internal-Tickets/interfaces';
import { DataTableHeader } from 'vuetify';
import SettingEntity from '@/services/Internal-Tickets/interfaces/setting.entity';
import EditSettingDialog from '@/components/dialogs/internal-tickets/EditSettingDialog.vue';
import DeleteSettingDialog from '@/components/dialogs/internal-tickets/DeleteSettingDialog.vue';
import CreateSetting from '@/views/pages/internal-tickets/CreateSetting.vue';
import TicketSettingsEditDialog from '@/views/pages/internal-tickets/TicketSettingsEditDialog.vue';

@Component({
  inject: ['internalTicketsRepository'],
  components: {
    TicketSettingsEditDialog,
    CreateSetting,
    EditSettingDialog,
    DeleteSettingDialog
  }
})
export default class Setting extends Vue {
  private loading: boolean = true;

  @Prop() private setting: any[];
  @Prop() private type: SettingType


  private readonly internalTicketsRepository: InternalTicketsRepositoryInterface;

  private headers: DataTableHeader[] = [
    { text: 'Id', value: 'id' },
    { text: 'Name', value: 'name' },
    { text: 'color', value: 'color' },
    { text: 'Actions', value: 'actions', sortable: false },
  ];

  private async mounted(): Promise<void> {
    this.loading = false;
  }

  private async editSetting(setting: SettingEntity): Promise<void> {
    this.$emit('openEditDialog',setting,this.type)
  }

  private async deleteSettingPrompt(setting: SettingEntity): Promise<void> {
    this.$emit('openDeleteDialog',setting,this.type)
  }

  public async onSettingCreated(type: SettingType) {
    this.$emit('onSettingCreated',this.type)
  }
}

